import React, { useEffect, useState } from 'react';
import useDragTranslate from '../hooks/useDragTranslate';
import { getRandomWindowPosition } from '../utils/windowPositioning';
/* resume window component */

const ResumeWindow = ({ onClose, zIndex, onFocus }) => {
  const { elRef, onPointerDown, onPointerMove, onPointerUp } = useDragTranslate(onFocus);
  const [isMobile, setIsMobile] = useState(false);
  
  // Generate random position for this window
  const [windowPosition] = useState(() => getRandomWindowPosition(805, 750));
  /* drag functionality for this window */
  
  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 770);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  const handleFocus = () => {
    onFocus && onFocus();
    /* bring window to front when clicked */
  };

  const handleClose = () => {
    // 1) add .closing
    elRef.current?.classList.add('closing');
    /* start the close animation */

    // 2) after animation end, call onClose to unmount
    const done = () => {
      elRef.current?.removeEventListener('animationend', done);
      onClose();
    };
    elRef.current?.addEventListener('animationend', done, { once: true });
    /* wait for animation to finish then actually close */
  };

  useEffect(() => {
    // listen on the document so we can move outside the window bounds
    document.addEventListener('pointermove', onPointerMove);
    document.addEventListener('pointerup', onPointerUp);
    /* set up drag event listeners */
    return () => {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      /* clean up listeners */
    };
  }, [onPointerMove, onPointerUp]);

  return (
    <div
      ref={elRef}
      className="window"
      data-window="skills"
      style={isMobile ? {
        display: 'block',
        width: '300px',
        height: '200px',
        zIndex: zIndex,
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        // Mobile: centered, compact window
      } : {
        display: 'block',
        width: '805px',
        height: '750px',
        zIndex: zIndex,
        position: 'fixed',
        '--tx': `${windowPosition.tx}px`,
        '--ty': `${windowPosition.ty}px`,
        // Desktop: draggable window
      }}
      onClick={handleFocus}
    >
      <div className="title-bar draggable" onPointerDown={onPointerDown}>
        <div className="title-bar-text">Resume - Adobe Reader</div>
        <div className="title-bar-controls">
          <button aria-label="Close" onClick={handleClose}></button>
        </div>
      </div>
      {/* window title bar with close button */}
      <div className="window-body" style={{ 
        padding: isMobile ? '20px' : '0', 
        height: isMobile ? 'calc(100% - 30px)' : 'calc(100% - 30px)', 
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        scrollbarColor: '#c0c0c0 #f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        boxSizing: 'border-box'
      }}>
        {isMobile ? (
          <a 
            href="/assets/Avo_s_Resume.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              backgroundColor: '#4CAF50',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 'bold',
              border: '1px solid #45a049',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
          >
            View Resume
          </a>
        ) : (
          <iframe
            src="/assets/Avo_s_Resume.pdf#toolbar=0&navpanes=0&scrollbar=0"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              display: 'block',
              scrollbarWidth: 'thin',
              scrollbarColor: '#c0c0c0 #f0f0f0'
            }}
            title="Avo's Resume"
          />
        )}
        {/* PDF viewer for resume */}
      </div>
    </div>
  );
};

export default ResumeWindow;
